export class CUSTOM_FIELD_WRAPPER {  
  static readonly customContainer = 'custom-container';
}
